/* eslint-ignore */
// @ts-nocheck
import React, { Component } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Form as BootstrapForm } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { IoMdArrowBack, IoMdPersonAdd } from 'react-icons/io';
import { MdLockOutline, MdPermIdentity, MdPlayArrow } from 'react-icons/md';
import api from '~/services/api';
import TextField from '~/components/layout/form/textField';
import ContainedButton from '~/components/layout/form/containedButton';
import OutlinedButton from '~/components/layout/form/outlinedButton';
import { toggleStep } from '~/store/actions/singup-actions';
import { ReactComponent as IconFormUser } from '~/assets/icons/form-user.svg';
import { FormBox, FormHeader } from './styles';

const regex =
  /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])(?=.{8,})/;

class SignupComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showPassword: false,
    };
  }

  SignUpSchema = () =>
    Yup.object().shape({
      password: Yup.string()
        .required('Insira uma senha')
        .matches(
          regex,
          'Use oito ou mais caracteres com uma combinação de letras, números e símbolos'
        ),
      passwordConfirmation: Yup.string()
        .required('Insira a confirmação de sua senha')
        .oneOf([Yup.ref('password'), null], 'As senhas não combinam'),
    });

  requestRegisterPassword = (values) => {
    this.setState({ loading: true });
    const { contactId, url, userId } = this.props;
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      contactId,
      password: values.password,
      passwordConfirmation: values.passwordConfirmation,
    };
    api
      .post(
        `industrial/customer/v1/users/${userId}/passwords`,
        body,
        parameters
      )
      .then((res) => {
        this.setState({ loading: false });
        this.sendValidationToken(contactId, userId, url);
      })
      .catch((err) => {
        this.setState({ loading: false });
        const erro = err.response;
        if (erro) {
          const { message } = err.response.data;
          if (err.response.status !== 401) {
            toast.error(message);
          }
        } else if (err.response.status !== 401) {
          toast.error('Ocorreu um erro interno na aplicação');
        }
      });
  };

  sendValidationToken = (contactId, userId, url) => {
    const header = {
      'Content-Type': 'application/json',
      access_token: localStorage.getItem('@UltragazEmpresarial:accessToken'),
    };
    const parameters = {
      method: 'POST',
      headers: header,
    };
    const body = {
      tokenType: 'REGISTER',
      url: process.env.REACT_APP_REGISTER_URL_CONFIRMATION,
      contactId,
    };
    api
      .post(`industrial/customer/v1/users/${userId}/tokens`, body, parameters)
      .then((res) => {
        this.props.dispatch(toggleStep(5));
      })
      .catch((err) => {
        const erro = err.response.data;
        if (erro) {
          const { message } = err.response.data;
          toast.error(message);
        } else {
          toast.error('Ocorreu um erro interno na aplicação');
          toast.error(
            'Certifique-se de estar conectado a internet ou tente novamente mais tarde!'
          );
        }
      });
  };

  handlePassVisibility() {
    const { showPassword } = this.state;
    this.setState({ showPassword: !showPassword });
  }

  render() {
    const { contactName } = this.props;
    return (
      <FormBox>
        <Formik
          initialValues={{
            password: '',
            confirmPassword: '',
          }}
          onSubmit={(values) => {
            this.requestRegisterPassword(values);
          }}
          validationSchema={this.SignUpSchema}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <Form>
              <BootstrapForm.Group controlId="email">
                <TextField
                  id="email"
                  type="text"
                  label="Seu e-mail"
                  ariaLabel="Seu e-mail"
                  ariaRequired
                  errorCondition={errors.email && touched.email}
                  errorMessage={errors.email}
                  title="Seu e-mail"
                  onBlur={handleBlur}
                  placeholder="E-mail"
                  label="E-mail"
                  value={contactName}
                  onChange={this.state.userEmail}
                  LeadingIcon={() => <IconFormUser />}
                />
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="password">
                <TextField
                  id="password"
                  type={this.state.showPassword ? 'text' : 'password'}
                  label="Senha"
                  ariaLabel="Senha"
                  ariaRequired
                  errorCondition={errors.password && touched.password}
                  errorMessage={errors.password}
                  title="Sua senha"
                  onBlur={handleBlur}
                  placeholder="Senha"
                  label="Senha"
                  showChangeTextPassword="true"
                  value={values.password}
                  onChange={handleChange}
                  LeadingIcon={() => <MdLockOutline size={25} />}
                />
              </BootstrapForm.Group>
              <BootstrapForm.Group controlId="passwordConfirmation">
                <TextField
                  id="passwordConfirmation"
                  type="password"
                  label="Confirmação de Senha"
                  ariaLabel="Confirmação de Senha"
                  showChangeTextPassword="true"
                  ariaRequired
                  errorCondition={
                    errors.passwordConfirmation && touched.passwordConfirmation
                  }
                  errorMessage={errors.passwordConfirmation}
                  title="Confirmação de Senha"
                  onBlur={handleBlur}
                  placeholder="Confirme a senha"
                  label="Confirme a senha"
                  value={values.passwordConfirmation}
                  onChange={handleChange}
                  LeadingIcon={() => <MdLockOutline size={25} />}
                />
              </BootstrapForm.Group>
              <div style={{ marginTop: 50 }}>
                <ContainedButton
                  className="mb-2"
                  block
                  type="submit"
                  icon="account-plus"
                  text="Confirmar"
                  color="#288efd"
                  loading={this.state.loading}
                  name="confirmar"
                  id="confirmar"
                  width="100%"
                  TrailingIcon={() => <IoMdPersonAdd size={20} />}
                >
                  Confirmar
                </ContainedButton>
                <OutlinedButton
                  onClick={() => this.props.dispatch(toggleStep(2))}
                  className="mb-2"
                  block
                  outline
                  text="Voltar"
                  color="#76d2e1"
                  name="Voltar"
                  id="Voltar"
                  width="100%"
                  LeadingIcon={() => <IoMdArrowBack size={20} />}
                >
                  Voltar
                </OutlinedButton>
              </div>
            </Form>
          )}
        />
      </FormBox>
    );
  }
}

const mapStateToProps = (state) => ({
  contactName: state.signUpReducer.contactName,
  contactId: state.signUpReducer.contactId,
  url: state.signUpReducer.url,
  customerCode: state.signUpReducer.customerCode,
  siteId: state.signUpReducer.siteId,
  userId: state.signUpReducer.userId,
});

export default connect(mapStateToProps)(SignupComponent);
